export enum UserAttention {
  None = 'None',
  UnsavedData = 'UnsavedData',
  NonSavableData = 'NonSavableData',
  Connecting = 'Connecting',
}
